export const VERSION = '6.0.12';
